import { nanoid as r } from "nanoid";
import { inject as n, provide as p } from "vue";
const t = Symbol(), i = () => n(t, "body"), d = (e) => {
  const o = e ?? `scalar-teleport-${r()}`;
  return p(t, `#${o}`), o;
};
export {
  t as TELEPORT_SYMBOL,
  d as useProvideTeleport,
  i as useTeleport
};
